var chunkMapping = {
	"182": [
		57801
	],
	"3214": [
		3214
	],
	"3785": [
		93785
	],
	"4638": [
		24638
	],
	"5501": [
		45501
	],
	"7327": [
		67327
	]
};
var idToExternalAndNameMapping = {
	"3214": [
		"default",
		"./AvailabilityDetails",
		78460
	],
	"24638": [
		"default",
		"./AlternativesButtonWithModal",
		22186
	],
	"45501": [
		"default",
		"./BulkDiscountTiersDisplay",
		22186
	],
	"57801": [
		"default",
		"./PromotionLabelList",
		78460
	],
	"67327": [
		"default",
		"./GlobalHeader",
		78460
	],
	"93785": [
		"default",
		"./UidispatcherApiModule",
		56190
	]
};
var idToRemoteMap = {
	"3214": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"24638": [
		{
			"externalType": "script",
			"name": "sd_pdp_ui",
			"externalModuleId": 22186
		}
	],
	"45501": [
		{
			"externalType": "script",
			"name": "sd_pdp_ui",
			"externalModuleId": 22186
		}
	],
	"57801": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"67327": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"93785": [
		{
			"externalType": "script",
			"name": "uidispatcher_api",
			"externalModuleId": 56190
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}